import common from './modules/common'

// 事件列表
var funcListConfig = {
  // common
  common,

}

export default funcListConfig
